import { api } from "@/frontend/services/api";
import type {
  CreatePrizeTypeRequestDTO,
  UpdatePrizeTypeRequestDTO,
  PrizeTypeResponseDTO,
  PrizeTypesPaginatedResponseDTO,
  ApiResponse,
  PaginationRequestDTO,
} from "@/shared/dto";

const BASE_URL = "/prize-types/private";

export const prizeTypeService = {
  getPaginate: (params?: PaginationRequestDTO) =>
    api.getWithParams<ApiResponse<PrizeTypesPaginatedResponseDTO>>(BASE_URL, params),
  getById: (id?: string) =>
    api.get<ApiResponse<PrizeTypeResponseDTO>>(`${BASE_URL}/${id}`),
  create: (data: CreatePrizeTypeRequestDTO) =>
    api.post<ApiResponse<PrizeTypeResponseDTO>>(BASE_URL, data),
  update: (id: string, data: UpdatePrizeTypeRequestDTO) =>
    api.put<ApiResponse<PrizeTypeResponseDTO>>(`${BASE_URL}/${id}`, data),
  delete: (id: string) => api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
};
